import { render, staticRenderFns } from "./footerDescription.vue?vue&type=template&id=6005dbc4&scoped=true&"
import script from "./footerDescription.vue?vue&type=script&lang=js&"
export * from "./footerDescription.vue?vue&type=script&lang=js&"
import style0 from "./footerDescription.vue?vue&type=style&index=0&id=6005dbc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6005dbc4",
  null
  
)

export default component.exports